/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaptureLabelKind } from './CaptureLabelKind';
import {
    CaptureLabelKindFromJSON,
    CaptureLabelKindFromJSONTyped,
    CaptureLabelKindToJSON,
    CaptureLabelKindToJSONTyped,
} from './CaptureLabelKind';

/**
 * 
 * @export
 * @interface CreateCaptureLabelRequest
 */
export interface CreateCaptureLabelRequest {
    /**
     * 
     */
    kind: CaptureLabelKind;
    /**
     * 
     */
    category?: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    description?: string | null;
}



/**
 * Check if a given object implements the CreateCaptureLabelRequest interface.
 */
export function instanceOfCreateCaptureLabelRequest(value: object): value is CreateCaptureLabelRequest {
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateCaptureLabelRequestFromJSON(json: any): CreateCaptureLabelRequest {
    return CreateCaptureLabelRequestFromJSONTyped(json, false);
}

export function CreateCaptureLabelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCaptureLabelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'kind': CaptureLabelKindFromJSON(json['kind']),
        'category': json['category'] == null ? undefined : json['category'],
        'name': json['name'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
    };
}

export function CreateCaptureLabelRequestToJSON(json: any): CreateCaptureLabelRequest {
    return CreateCaptureLabelRequestToJSONTyped(json, false);
}

export function CreateCaptureLabelRequestToJSONTyped(value?: CreateCaptureLabelRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'kind': CaptureLabelKindToJSON(value['kind']),
        'category': value['category'],
        'name': value['name'],
        'description': value['description'],
    };
}

